import React, { useState } from "react"
import tw from "twin.macro"

import {
  Link,
  Element,
  Events,
  animateScroll as scroll,
  scrollSpy,
  scroller,
} from "react-scroll"
const NavbarData = [
  {
    name: "Pergo",
    link: "/",
  },
  {
    name: "About Me",
    link: "HEROSECTION",
  },
  {
    name: "Portfolio",
    link: "SERVICESECTION",
  },
  {
    name: "Reviews",
    link: "DESIGNSAMPLE",
  },
  {
    name: "My Blogs",
    link: "STORIES",
  },
  // {
  //name: "Hire Me",
  // link: "/",
  //  },
]
const Navbar = () => {
  const [changenavbar, setchangenavbar] = useState(false)

  function changebackground() {
    if (typeof window !== "undefined") {
      if (window.scrollY >= 10) setchangenavbar(true)
      else setchangenavbar(false)
    }
  }
  if (typeof window !== "undefined") {
    window.addEventListener("scroll", changebackground)
  }
  return (
    <div
      css={[!changenavbar ? tw`bg-transparent` : tw`bg-black text-white`]}
      tw="fixed z-10 top-0  w-full   p-5 text-blue-50"
    >
      <div tw="md:space-x-5 mx-auto max-w-xl ">
        <div tw=" flex flex-wrap space-x-2 md:(flex space-x-7) mx-auto ">
          {NavbarData.map((item, index) => (
            <div key={index}>
              <Link
                activeClass="active"
                tw="cursor-pointer whitespace-nowrap"
                to={item.link}
                spy={true}
                smooth={true}
                duration={500}
              >
                {item.name}
              </Link>{" "}
            </div>
          ))}
          <button tw="hidden md:flex bg-red-700 hover:bg-blue-400 w-24 rounded-lg h-6 text-base mt-0.5 mx-auto focus:outline-none border-radius[2rem] ">
            <div tw="mx-auto">Hire Me</div>
          </button>
        </div>

        <div tw="flex justify-center">
          <button tw="bg-red-700 md:hidden hover:bg-blue-400 w-24 rounded-lg h-6 text-base mt-0.5 mx-auto focus:outline-none border-radius[2rem] ">
            Hire Me
          </button>
        </div>
      </div>
    </div>
  )
}

export default Navbar
